import { ThemeProvider as NextThemesProvider } from "next-themes";
import type { ReactNode } from "react";

/**
 * App-wide color-mode provider. Backed by next-themes, driving the `.dark`
 * class on <html>. Defaults to the user's OS preference; a persisted choice
 * (light/dark/system) overrides it. The no-FOUC pre-paint class is applied by
 * the inline script in `__root.tsx`, so this provider only owns runtime state.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
